import React from 'react';
import Swal from 'sweetalert2'
import updateEstatusTipoEgreso from '../../services/tipo_egreso/updateEstatusTipoEgreso';
import $ from 'jquery';
import deleteTipoEgreso from '../../services/tipo_egreso/deleteTipoEgreso';

export default function TableElementTipoEgreso({ element, permisosUsuario, reload, setElementToEdit }) {

    let { id_tipo_gasto, nombre, descripcion, activo } = element;

    const [estadoEstatus, setEstadoEstatus] = React.useState(activo);

    const onClickEstatus = (activo) => {
        let msg = (activo) ? 'Quieres activar el egreso?' : 'Quieres desactivar el egreso?';
        let txt = (activo) ? 'Activar' : 'Desactivar';
        Swal.fire({
            title: msg,
            showCancelButton: true,
            confirmButtonText: txt,
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if(result.isConfirmed){
                let values = new FormData()
                values.append('id_tipo_gasto', id_tipo_gasto)
                values.append('activo', activo ? '1' : '0')
                let objectValues = Object.fromEntries(values);
                // console.log({objectValues})
                updateEstatusTipoEgreso({values:objectValues}).then(response => {
                    console.log(response)
                    let _respuesta = JSON.parse(response);
                    if (_respuesta.response === "success") {
                        setEstadoEstatus(activo ? '1' : '0')
                        Swal.fire({
                            timer: 1200,
                            title: 'Estatus actualizado',
                            showConfirmButton: false,
                            icon: 'success'
                        })
                    }
                    
                })
            }
        })
    }

    const onUpdateElement = ()=>{
        // setElementToEdit(null)
        setElementToEdit(element)
        $("#modalAddTipoEgreso").modal('show')
    }

    const onClickDelete = () => {
        let msg = 'Seguro que quieres eliminarlo?';
        let txt = 'Si';
        Swal.fire({
            title: msg,
            showCancelButton: true,
            confirmButtonText: txt,
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if(result.isConfirmed){
                let values = new FormData()
                values.append('id_tipo_gasto', id_tipo_gasto)
                let objectValues = Object.fromEntries(values);
                // console.log({objectValues})
                deleteTipoEgreso({values:objectValues}).then(response => {
                    console.log(response)
                    let _respuesta = JSON.parse(response);
                    if (_respuesta.response === "success") {
                        reload()
                        Swal.fire({
                            timer: 1200,
                            title: 'Eliminado',
                            showConfirmButton: false,
                            icon: 'success'
                        })
                    } else {
                        Swal.fire({
                            title: 'No se puede eliminar',
                            text: 'Ya existen registros que están vinculados a este tipo de egreso, para eliminarlo, primero elimina todos los registros al que está vinculado.',
                            icon: 'info'
                        })
                    }
                    
                })
            }
        })
    }

    return (
        <tr key={id_tipo_gasto}>
            <th>
                <div className="table__name">
                    <div className="dropdown">
                        <button type="button" className="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {/* <Link to={`/procesos/${id_tipo_gasto}`} className="dropdown-item" >Ver</Link> */}
                            {
                                (permisosUsuario.tipoEgresos.editar === '1') &&
                                    (estadoEstatus === '1' ?
                                    <a className="dropdown-item text-black" onClick={() => onClickEstatus(false)}>Deshabilitar</a>
                                    :
                                    <a className="dropdown-item bg-success text-white" onClick={() => onClickEstatus(true)}>Habilitar</a>)
                            }

                            {
                                (permisosUsuario.tipoEgresos.editar === '1') &&
                                    <a className="dropdown-item text-black" onClick={() => onUpdateElement()}>Editar</a>
                            }

                            {
                                (permisosUsuario.tipoEgresos.eliminar === '1') &&
                                    <a className="dropdown-item bg-danger text-white" onClick={() => onClickDelete()}>Eliminar</a>
                            }
                        </div>
                    </div>

                    <div className="table__nameDescription">
                        <p>{nombre}</p>
                        <small>id egreso: {id_tipo_gasto}</small>
                    </div>
                </div>
            </th>

            <td>
                <p>{descripcion ? descripcion : '-'}</p>
            </td>

            <td>
                <div className="table__estatus">
                    <span className={ estadoEstatus === '1' ? '' : 'table__estatus-inactive' }>
                        { estadoEstatus === '1' ? 'Activo' : 'Inactivo' }
                    </span>
                </div>
            </td>
        </tr>
    )
    
}